import { render } from "./NewsInfo.vue?vue&type=template&id=8ea72f02&scoped=true"
import script from "./NewsInfo.vue?vue&type=script&lang=js"
export * from "./NewsInfo.vue?vue&type=script&lang=js"

import "./NewsInfo.vue?vue&type=style&index=0&id=8ea72f02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea72f02"]])

export default __exports__